import type { Locale } from "@/shared/utils";
import type { Project } from "../../../types";
import ProjectGridCard from "../../ProjectsPage/components/ProjectGridCard";

interface SimilarProjectsSectionProps {
  projects: Project[];
  locale: Locale;
  t: (key: string, opts?: Record<string, unknown>) => string;
  onProjectClick: (id: number) => void;
}

export default function SimilarProjectsSection({ projects, t, onProjectClick }: SimilarProjectsSectionProps) {
  return (
    <div className="flex flex-col gap-5">
      <h3 className="text-display-xs content-base-primary">{t("detail.similarProjects")}</h3>
      <div className="grid grid-cols-2 gap-4">
        {projects.slice(0, 2).map((project) => (
          <ProjectGridCard
            key={project.id}
            project={project}
            onClick={onProjectClick}
            onEdit={() => {}}
            canEdit={false}
          />
        ))}
      </div>
    </div>
  );
}
